import React, { FC, useState } from 'react';
import {
  Box,
  Button,
  Stack,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import { SelectChangeEvent } from '@mui/material/Select';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import { useRegistrationContext } from '../../contexts/RegistrationContext';

interface DepartmentSelectionFormProps {
  onNext: () => void;
  onBack: () => void;
}

export const DepartmentSelectionForm: FC<DepartmentSelectionFormProps> = ({
  onNext,
  onBack,
}) => {
  const [department, setDepartment] = useState<string>('');
  const { updateField } = useRegistrationContext();

  // ✅ OBTENER DEPARTAMENTOS DE LA EMPRESA SELECCIONADA
  const { departments = [] } = useSelector(
    (state: RootState) => state.business
  );

  const handleDepartmentChange = (event: SelectChangeEvent) => {
    const activationCode = event.target.value;
    setDepartment(activationCode);
    // ✅ ACTUALIZAR EL activationCode EN EL FORMULARIO DE REGISTRO
    updateField('activationCode', activationCode);
  };

  return (
    <Box sx={{ paddingX: '5%', paddingY: '5vh' }}>
      <Button
        onClick={onBack}
        size="small"
        sx={{ marginY: '2%', fontWeight: 'bold' }}
        variant="text"
      >
        {'← Atras'}
      </Button>
      <FormControl sx={{ width: '100%', marginTop: '10vh' }}>
        <InputLabel id="department-select-label">Departamento</InputLabel>
        <Select
          value={department}
          onChange={handleDepartmentChange}
          labelId="department-select-label"
          id="department-select"
          label="Departamento"
          variant="outlined"
          sx={{ width: '100%' }}
        >
          {/* ✅ DEPARTAMENTOS DINÁMICOS DE LA EMPRESA SELECCIONADA */}
          {departments.map(dept => (
            <MenuItem key={dept.name} value={dept.activationCode}>
              {dept.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <Stack
        direction="row"
        justifyContent="center"
        alignItems="center"
        spacing={12}
      >
        <Button
          disabled={!department}
          onClick={onNext}
          size="large"
          sx={{ marginY: '5vh', fontWeight: 'bold', borderRadius: '50px' }}
          variant="contained"
        >
          {'Siguiente →'}
        </Button>
      </Stack>
    </Box>
  );
};
